"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var StyledHelpText = styled_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 13px;\n  color: ", ";\n"], ["\n  font-size: 13px;\n  color: ", ";\n"])), tokens_1.colors.text.secondary);
var HelpText = function (props) { return React.createElement(StyledHelpText, { id: props.id }, props.children); };
exports.default = HelpText;
var templateObject_1;
//# sourceMappingURL=help-text.js.map